import {
  InlineButton,
  labelDefaultMediumStyles,
  labelDefaultRegularStyles,
  labelLargeMediumStyles
} from '@lifebit-ai/lds'
import styled from 'styled-components'

export const Header = styled.div`
  align-items: baseline;
  display: flex;
  gap: ${({ theme }) => theme.size.space['03']};
  justify-content: space-between;
`

export const Title = styled.h3`
  ${labelLargeMediumStyles}
  color: ${({ theme }) => theme.color.content.main as string};
  margin: 0;
`

export const Count = styled.span`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.subtle as string};
`

export const Events = styled.ol`
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
`

export const Event = styled.li`
  display: flex;
  gap: ${({ theme }) => theme.size.space['03']};
`

/**
 * Fixed-width gutter holding the icon and the connector, mirroring the import progress stepper
 * so the two timelines line up when both appear on a request.
 */
export const Rail = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: ${({ theme }) => theme.size.space['02']};
  padding: ${({ theme }) => theme.size.space['01']} 0;
  width: 19px;
`

export const Icon = styled.div`
  display: flex;

  svg {
    height: ${({ theme }) => theme.size.icon.small};
    width: ${({ theme }) => theme.size.icon.small};
  }

  svg path {
    fill: ${({ theme }) => theme.color.content.secondary as string};
  }

  /*
   * Outline icons (the tag, for one) are drawn as a stroke on a fill-less svg. Filling those
   * paths turns the outline into a solid blob, so colour the stroke instead.
   */
  svg[fill='none'] path[stroke] {
    fill: none;
    stroke: ${({ theme }) => theme.color.content.secondary as string};
  }
`

export const Connector = styled.div`
  background: ${({ theme }) => theme.color.border.default as string};
  flex: 1;
  min-height: ${({ theme }) => theme.size.space['04']};
  width: 1px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['02']};
  min-width: 0;
  padding-bottom: ${({ theme }) => theme.size.space['05']};

  ${Event}:last-child & {
    padding-bottom: 0;
  }
`

export const Heading = styled.div`
  column-gap: ${({ theme }) => theme.size.space['03']};
  display: flex;
  flex-wrap: wrap;
`

export const EventTitle = styled.span`
  ${labelDefaultMediumStyles}
  color: ${({ theme }) => theme.color.content.main as string};
`

export const Timestamp = styled.span`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.subtle as string};
`

export const Note = styled.span`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.secondary as string};
  overflow-wrap: anywhere;
`

export const EmptyMessage = styled.p`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.secondary as string};
  margin: 0;
`

export const RevealButton = styled(InlineButton)`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: ${({ theme }) => theme.size.space['02']};

  svg {
    height: ${({ theme }) => theme.size.icon.small};
    width: ${({ theme }) => theme.size.icon.small};
  }
`
